<template>
    <div class="news-section">
        <div class="news-title">雾曼动态</div>
        <div class="news-list">
            <div class="news-item" 
                v-for="(item, index) in newsItems" 
                :key="index"
                @click="goToDetail(item.contentId)"
                style="cursor: pointer;">
                <div class="news-image-wrapper">
                    <img :src="item.image" alt="" class="news-image">
                </div>
                <div class="news-content">
                    <div class="news-content-title">{{ item.title }}</div>
                    <div class="news-content-desc">{{ item.desc }}</div>
                </div>
            </div>
        </div>
        <div class="view-more" @click="goToDynamic">
            <div class="view-more-text">查看更多</div>
            <div class="view-more-icon">
                <img src="../assets/home8.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsSection',
    data() {
        return {
            newsItems: []
        }
    },
    created() {
        this.getNews()
    },
    methods: {
        getNews() {
            this.$http.get('/cms/content/front-list?pageNum=1&pageSize=3&catalogId=636460636414021').then(res => {
                if (res.code === 200 && res.data.rows) {
                    // 处理返回的数据，将API返回的数据格式转换为组件需要的格式
                    this.newsItems = res.data.rows.map(item => ({
                        image: item.logoSrc || require('../assets/home5.png'), // 暂时使用默认图片
                        title: item.title,
                        desc: item.subTitle || '暂无描述', // 如果API中没有description字段，显示默认文本
                        contentId: item.contentId // 保存文章ID，可能后续需要用到
                    }));
                } else {
                    throw new Error('获取数据失败');
                }
            }).catch(error => {
                console.error('获取新闻列表失败:', error);
                // 加载失败时使用默认数据
                this.newsItems = [
                    {
                        image: require('../assets/home5.png'),
                        title: '雾曼入选2024年度农业"火花技术"成果库',
                        desc: '近日，农业农村部科学技术司公布了2024年度…'
                    },
                    {
                        image: require('../assets/home7.png'),
                        title: '雾漫荣获2024"松湖杯"创新创业大赛先锋奖！',
                        desc: '12月3日，以"才聚松山湖 筑梦科学城"为主题的2024年"松湖…'
                    },
                    {
                        image: require('../assets/home6.png'),
                        title: '《植保智能漫雾机通用技术规范》意见征集',
                        desc: '深圳雾曼科技有限公司关于《植保智能漫雾机通用技术规范》…'
                    }
                ]
            });
        },
        goToDetail(contentId) {
            this.$router.push({
                name: 'NewsDetail',
                query: {
                    id: contentId
                }
            })
        },
        goToDynamic() {
            this.$router.push('/Dynamic')
        }
    }
}
</script>

<style scoped>
.news-section {
    background: #F5F6F7;
    padding: 80px 0;
}

.news-title {
    font-size: 40px;
    font-weight: 600;
    color: #000000;
    text-align: center;
    margin-bottom: 48px;
}

.news-list {
    width: 1470px;
    margin: 0 auto;
    display: flex;
    gap: 30px;
    justify-content: center;
}

.news-item {
    width: 470px;
    height: 433px;
    background: #FFFFFF;
    border-radius: 12px;
    overflow: hidden;
    transition: transform 0.3s ease;
}

.news-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.news-image-wrapper {
    width: 470px;
    height: 320px;
}

.news-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px 12px 0 0;
}

.news-content {
    padding: 24px 32px;
}

.news-content-title {
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 12px;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.news-content-desc {
    font-size: 15px;
    color: #666666;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}

.view-more {
    width: 148px;
    height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    border: 1px solid rgba(0,0,0,0.5);
    margin: 27px auto;
}

.view-more-text {
    font-size: 16px;
    font-weight: 400;
    color: #666666;
}

.view-more-icon {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
}

.view-more-icon img {
    width: 100%;
    height: 100%;
}

.view-more:hover .view-more-text {
    color: #333333;
}

@media screen and (max-width: 768px) {
    .news-section {
        padding: 40px 0;
    }

    .news-title {
        font-size: 32px;
        margin-bottom: 24px;
    }

    .news-list {
        width: 100%;
        padding: 0 15px;
        flex-direction: column;
        gap: 15px;
    }

    .news-item {
        width: 100%;
        height: auto;
    }

    .news-image-wrapper {
        width: 100%;
        height: 200px;
    }

    .news-content {
        padding: 16px 20px;
    }

    .news-content-title {
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 8px;
    }

    .news-content-desc {
        font-size: 14px;
        line-height: 20px;
    }

    .view-more {
        margin: 20px auto;
    }
}
</style> 